import React, { useState, useEffect, useCallback } from "react";
import { HubConnectionBuilder, HttpTransportType, HubConnectionState } from "@microsoft/signalr";
import { env } from "utils/env";
import { useReactOidc } from "@axa-fr/react-oidc-context";

function NotificationProvider() {
  const { oidcUser, logout } = useReactOidc();
  const access_token = oidcUser?.access_token;
  const [signalRConnection, setSignalRConnection] = useState(null);

  const createSignalRConnection = useCallback(() => {
    const con = new HubConnectionBuilder()
      .withUrl(`${env.REACT_APP_SIGNALR_SERVER}/notificationHub`, {
        accessTokenFactory: () => access_token,
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    setSignalRConnection(con);

    con.on("Logout", () => {
      if (typeof logout === "function") logout();
      localStorage.setItem("serverTriggeredLogout", "true");
    });
    con.onclose(() => console.log("SignalR connection closed"));
    con.onreconnecting(() => console.log("SignalR reconnecting"));
    con.onreconnected(() => console.log("SignalR reconnected"));
  }, [logout, access_token]);

  const tryStartConnection = useCallback(() => {
    if (!signalRConnection) return;
    signalRConnection
      .start()
      .then(() => console.log("SignalR connection started"))
      .catch((error) => console.log("SignalR connection error", error));
  }, [signalRConnection]);

  useEffect(() => {
    if (!signalRConnection && !access_token) return;
    if (!signalRConnection && access_token) {
      createSignalRConnection();
      return;
    }
    if (signalRConnection?.state === HubConnectionState.Connected) return;
    tryStartConnection();
  }, [tryStartConnection, createSignalRConnection, signalRConnection, access_token]);

  //close connection when component unmounts
  useEffect(() => {
    return () => {
      signalRConnection?.stop();
    };
  }, [signalRConnection]);

  return React.Fragment;
}

export default NotificationProvider;
